import { useEffect, useState } from "react";
import api from "@/lib/api";
import ConservationPill from "@/components/ConservationPill";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";

export default function HeritageDb() {
  const [breeds, setBreeds] = useState([]);
  const [species, setSpecies] = useState("all");
  const [status, setStatus] = useState("all");
  const [q, setQ] = useState("");

  useEffect(() => {
    const p = {};
    if (species !== "all") p.species = species;
    if (status !== "all") p.status = status;
    api.get("/heritage-breeds", { params: p }).then(r => setBreeds(r.data.breeds));
  }, [species, status]);

  const filtered = breeds.filter(b => b.breed.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10">
      <h1 className="heading text-3xl sm:text-4xl font-extrabold tracking-tight">Heritage Breed Conservation Database</h1>
      <p className="text-stone-600 mt-2 max-w-2xl">Referenced from the Livestock Conservancy (US) priority list and FAO DAD-IS. Every marketplace lot is auto-flagged with its current conservation status.</p>

      <div className="mt-6 grid md:grid-cols-3 gap-3">
        <Input data-testid="heritage-search" placeholder="Search breed…" value={q} onChange={(e) => setQ(e.target.value)} />
        <Select value={species} onValueChange={setSpecies}>
          <SelectTrigger data-testid="heritage-species-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All species</SelectItem>
            <SelectItem value="cattle">Cattle</SelectItem>
            <SelectItem value="equine">Equine</SelectItem>
            <SelectItem value="sheep">Sheep</SelectItem>
            <SelectItem value="swine">Swine</SelectItem>
            <SelectItem value="goat">Goat</SelectItem>
            <SelectItem value="canine">Canine</SelectItem>
            <SelectItem value="camel">Camel</SelectItem>
            <SelectItem value="poultry">Poultry</SelectItem>
          </SelectContent>
        </Select>
        <Select value={status} onValueChange={setStatus}>
          <SelectTrigger data-testid="heritage-status-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All statuses</SelectItem>
            <SelectItem value="CRITICAL">Critical</SelectItem>
            <SelectItem value="THREATENED">Threatened</SelectItem>
            <SelectItem value="WATCH">Watch</SelectItem>
            <SelectItem value="RECOVERING">Recovering</SelectItem>
            <SelectItem value="STABLE">Stable</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="mt-6 surface-card overflow-x-auto">
        <table className="data-table">
          <thead>
            <tr><th>Breed</th><th>Species</th><th>Status</th><th className="hidden md:table-cell">Origin</th><th className="hidden md:table-cell">Notes</th></tr>
          </thead>
          <tbody>
            {filtered.map((b, i) => (
              <tr key={i} data-testid={`heritage-row-${b.breed.replace(/\s/g, "-")}`}>
                <td className="font-medium">{b.breed}{b.source === "dadis" && <span data-testid={`heritage-dadis-badge-${b.breed.replace(/\s/g, "-")}`} className="ml-2 text-[10px] mono uppercase px-1.5 py-0.5 rounded-full bg-sky-100 text-sky-800">FAO DAD-IS</span>}</td>
                <td className="capitalize">{b.species}</td>
                <td><ConservationPill status={b.status} /></td>
                <td className="hidden md:table-cell">{b.origin}</td>
                <td className="hidden md:table-cell text-stone-600">{b.notes}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
